import content from "./seo_content.json";

export const PLACES = content.places;
export const PLACE_BY_SLUG = Object.fromEntries(PLACES.map((p) => [p.slug, p]));
export const LINKED_PLACES = content.placeLinks.map((s) => PLACE_BY_SLUG[s]).filter(Boolean); // the only /places pages we link to (others stay live)
export const PLACE_TEMPLATE = content.placeTemplate;
export const fillPlace = (tpl, place) => tpl.replace(/\{PLACE\}/g, place.name);
